export default __webpack_public_path__ + "static/media/autumn.daad6493.png";